import { styled } from "@mui/material";

export const StyledWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  marginInline: "auto",
  maxWidth: 300,
  textAlign: "center",
}));

export const StyledText = styled("h1")(({ theme: { palette } }) => ({
  color: palette.primary.main,
  fontSize: 22,
  marginBottom: 15,
  padding: 8,
}));
